import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'
import registerListenersDOM from './registerListenersDOM'
function finish() {
  registerListenersDOM()
  addAgencyIdAndExecuteFinishToRender()
}

export default finish
